<template>
    <div>
      <v-card class="main-card rounded-lg pa-6 mb-6">
        <div class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-store</v-icon>
            <h2 class="text-h5 font-weight-medium primary--text">{{ customers ? customers.length : 0 }} Insegne</h2>
          </div>
          <v-btn
            color="primary"
            text
            @click="addCustomer"
            class="px-4"
          >
            <v-icon left>mdi-plus</v-icon>
            Aggiungi Insegna
          </v-btn>
        </div>

        <v-data-table
            v-if="customers"
            :headers="headers"
            :items="customers"
            :items-per-page="dtOptions.itemsPerPage"
            :page.sync="dtOptions.page"
            hide-default-footer

            class="elevation-0"
        >
              <template #item.secondary="{ item }">
                <v-checkbox
                    v-model="item.secondary"
                    color="secondary"
                    hide-details
                    @click="onSecondaryClick(item)"
                    class="text-center"
                ></v-checkbox>
              </template>
              <template #item.actions="{ item }">
                <div class="d-flex justify-center">
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    class="mr-1"
                    @click="editCustomer(item)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="deleteCustomer(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
          </v-data-table>

          <custom-pagination
            v-if="customers && totalPages > 0"
            v-model="dtOptions.page"
            :total-items="customers ? customers.length : 0"
            :items-per-page="dtOptions.itemsPerPage"
            @update:items-per-page="updateItemsPerPage"
          ></custom-pagination>
      </v-card>

      <!-- Modali -->
      <customer-dialog
      v-if="showCustomerDialog"
      v-model="showCustomerDialog"
      :customer-id="selectedCustomerId"
      @customerSaved="onCustomerSaved"/>
      <customer-delete-dialog
      v-if="showCustomerDeleteDialog"
      v-model="showCustomerDeleteDialog"
      :customer-id="customerIdToDelete"
      @confirmed="loadCustomers()"/>
    </div>
</template>

<script>
import {format, parseISO} from "date-fns";
import CustomerDeleteDialog from "./CustomerDeleteDialog.vue";
import CustomerDialog from "./CustomerDialog.vue";
import CustomPagination from "../../components/widgets/CustomPagination";

export default {
    components: {
        CustomerDeleteDialog,
        CustomerDialog,
        CustomPagination
    },
    data: () => ({
        customers: null,
        showCustomerDialog: false,
        selectedCustomerId: null,
        customerIdToDelete: false,
        showCustomerDeleteDialog: false,
        dtOptions: {
            page: 1,
            itemsPerPage: 10
        },
    }),
    computed: {
        headers() {
            return [
                {value: 'name', text: 'Nome', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'address', text: 'Indirizzo', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'telephone', text: 'Telefono', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'email', text: 'Email', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'secondary', text: 'Secondario', class: "primary--text font-weight-medium text-center", align: 'center'},
                {value: 'actions', text: 'Azioni', class: "primary--text font-weight-medium text-center", align: 'center', sortable: false}
            ]
        },
        totalPages() {
            if (!this.customers) return 0;
            return Math.ceil(this.customers.length / this.dtOptions.itemsPerPage);
        }
    },
    mounted() {
        this.ensureUserInStore().then(() => {
            if (this.$store.state.user.role === 'MANAGEMENT_CONTROL') {
                this.$router.push({name: 'tasks'});
            }
        })
        this.loadCustomers()
    },
  methods: {
    addCustomer() {
      this.selectedCustomerId = null
      this.showCustomerDialog = true
    },
    deleteCustomer(item) {
      this.customerIdToDelete = item.id
      this.showCustomerDeleteDialog = true
    },
    editCustomer(item) {
      this.selectedCustomerId = item.id
      this.showCustomerDialog = true
    },
    formatDate(isoDate) {
      return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : ''
    },
    loadCustomers() {
      this.$customerService.list().then(
          response => {
            this.customers = response.data;
          }
      )
    },
    onCustomerSaved() {
      this.showCustomerDialog = false
      this.loadCustomers()
    },
    onSecondaryClick(item) {
      const data = {
        secondary: item.secondary
      }
      this.$customerService.patch(item.id, data)
          .then(() => {
            this.loadCustomers()
          })
          .catch(xhr => {
            this.$root.$emit('renderError', xhr)
          })
    },
    ensureUserInStore() {
      if (!this.$store.state.user) {
        return this.$store.dispatch('setCurrentUser');
      } else {
        return Promise.resolve();
      }
    },

    updateItemsPerPage(itemsPerPage) {
      this.dtOptions.itemsPerPage = itemsPerPage;
      this.dtOptions.page = 1; // Torna alla prima pagina quando cambia il numero di elementi per pagina
    }
  }
}
</script>
